import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {object} props - Props.
 * @returns {JSX.Element} Component.
 */
export const TeamWatermarkBackground = ( { teamAbbreviation, className = '' } ) => (
    <div className={ `statspro-team-watermark-background statspro-team-watermark-background--${ teamAbbreviation.toLowerCase() } ${ className }` }>
        <div className="statspro-team-watermark-background__overlay"></div>
        <div className="statspro-team-watermark-background__watermark"></div>
    </div>
);

TeamWatermarkBackground.propTypes = {
    teamAbbreviation: PropTypes.string.isRequired,
    className: PropTypes.string
};